import _ from "lodash";
import React, { Component } from "react";

//Utility imports
import { getHOCDisplayName } from "Utils";
import { goToPageNotFound } from "modules/NavigationModule";

//Third party imports
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Sentry } from "services/sentry";

const FALSY_VALUE_LIST = ["undefined", "null", "NaN"];

const withDynamicUrlValidation = ({
  component: WrappedComponent,
  urlValidationType,
  customUrlValidationFunction,
}) => {
  class WithDynamicUrlValidation extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isValidated: false,
      };
    }

    UNSAFE_componentWillMount = () => {
      const { goToPageNotFound, location: { pathname = "" } = {} } = this.props;

      const isUrlValidated = this.validateUrl();
      this.setState({ isValidated: isUrlValidated });

      if (!isUrlValidated) {
        goToPageNotFound();
        Sentry.captureMessage(`Invalid route: ${pathname}`);
      }
    };

    validateUrl = () => {
      const { route: { path = null } = {}, routeParams = {} } = this.props;
      return _.every(_.split(path, "/"), subPath => {
        if (_.includes(subPath, ":")) {
          const updatedPath = _.get(routeParams, subPath.substring(1), null);

          //If path is not present in routeParams or path has falsy values (undefined , null etc...) then return false
          if (!updatedPath || _.includes(FALSY_VALUE_LIST, updatedPath)) {
            return false;
          }

          switch (urlValidationType) {
            case "alphabetsOnly": {
              return /^[a-zA-Z]+$/.test(updatedPath);
            }
            case "alphanumeric": {
              return /^[a-zA-Z0-9]+$/.test(updatedPath);
            }
            case "number": {
              return !isNaN(updatedPath);
            }
            case "customValidation": {
              return customUrlValidationFunction({
                path: updatedPath,
                pathName: subPath,
              });
            }
            default: {
              return true;
            }
          }
        } else {
          return true;
        }
      });
    };

    render() {
      const { isValidated } = this.state;
      return isValidated ? <WrappedComponent {...this.props} /> : null;
    }
  }

  WithDynamicUrlValidation.displayName = `WithDynamicUrlValidation(${getHOCDisplayName(
    WrappedComponent
  )})`;

  const mapActionCreators = {
    goToPageNotFound,
  };

  return compose(
    withRouter,
    connect(null, mapActionCreators)
  )(WithDynamicUrlValidation);
};

export default withDynamicUrlValidation;
